// Static UI translations for chrome (nav, CTA, form labels)
export const UI = {
  es: {
    nav_home: "Inicio",
    nav_gallery: "Propiedades",
    nav_about: "Quiénes Somos",
    nav_contact: "Contacto",
    nav_admin: "Admin",
    hero_overline: "Inmobiliaria de Inversiones",
    hero_title: "Tierra, patrimonio,\nvisión de futuro.",
    hero_sub: "Inmuebles rurales, desarrollos urbanos de gran porte y áreas industriales. Oportunidades exclusivas de inversión en tierra en Paraguay.",
    hero_cta: "Explorar propiedades",
    hero_cta_alt: "Contactar",
    cat_rural: "Rural",
    cat_urban: "Urbano",
    cat_industrial: "Industrial",
    cat_rural_desc: "Estancias, campos productivos y montes nativos en las regiones más fértiles de Sudamérica.",
    cat_urban_desc: "Tierras estratégicas para desarrollos inmobiliarios de gran escala con factibilidad aprobada.",
    cat_industrial_desc: "Predios industriales y logísticos en corredores estratégicos con servicios completos.",
    gallery_title: "Propiedades",
    gallery_sub: "Una selección de oportunidades de inversión patrimonial.",
    filter_all: "Todas",
    view_details: "Ver detalles",
    close: "Cerrar",
    location: "Ubicación",
    size: "Superficie",
    price: "Valor",
    description: "Descripción",
    features: "Características",
    photos: "Fotografías",
    contact_for_info: "Solicitar información",
    contact_title: "Contáctenos",
    contact_sub: "Nuestro equipo responde consultas de inversión en un plazo máximo de 24 horas.",
    form_name: "Nombre completo",
    form_email: "Correo electrónico",
    form_phone: "Teléfono",
    form_message: "Mensaje",
    form_submit: "Enviar consulta",
    form_success: "Mensaje enviado. Le contactaremos en breve.",
    form_error: "Ocurrió un error al enviar. Intente nuevamente.",
    admin_login: "Acceso administrador",
    admin_email: "Email",
    admin_password: "Contraseña",
    admin_enter: "Ingresar",
    footer_rights: "Todos los derechos reservados.",
    footer_tagline: "Land & Real Estate Investments",
    translating: "Traduciendo...",
  },
};

// Fallback: for non-es chrome, we use ES text and translate via backend.
// Here we define a small set of translations for chrome directly (more reliable than translating every render).
UI.pt = { ...UI.es,
  nav_home: "Início", nav_gallery: "Propriedades", nav_about: "Quem Somos", nav_contact: "Contato", nav_admin: "Admin",
  hero_overline: "Imobiliária de Investimentos",
  hero_title: "Terra, patrimônio,\nvisão de futuro.",
  hero_sub: "Imóveis rurais, grandes desenvolvimentos urbanos e áreas industriais. Oportunidades exclusivas de investimento em terras no Paraguai.",
  hero_cta: "Ver propriedades", hero_cta_alt: "Contato",
  cat_rural: "Rural", cat_urban: "Urbano", cat_industrial: "Industrial",
  cat_rural_desc: "Estâncias, campos produtivos e matas nativas nas regiões mais férteis da América do Sul.",
  cat_urban_desc: "Terras estratégicas para grandes desenvolvimentos imobiliários com viabilidade aprovada.",
  cat_industrial_desc: "Terrenos industriais e logísticos em corredores estratégicos com infraestrutura completa.",
  gallery_title: "Propriedades", gallery_sub: "Uma seleção de oportunidades de investimento patrimonial.",
  filter_all: "Todas", view_details: "Ver detalhes", close: "Fechar",
  location: "Localização", size: "Área", price: "Valor", description: "Descrição", features: "Características", photos: "Fotografias",
  contact_for_info: "Solicitar informações",
  contact_title: "Fale Conosco", contact_sub: "Nossa equipe responde consultas em até 24 horas.",
  form_name: "Nome completo", form_email: "E-mail", form_phone: "Telefone", form_message: "Mensagem",
  form_submit: "Enviar consulta", form_success: "Mensagem enviada. Entraremos em contato.",
  form_error: "Ocorreu um erro. Tente novamente.",
  admin_login: "Acesso administrador", admin_email: "E-mail", admin_password: "Senha", admin_enter: "Entrar",
  footer_rights: "Todos os direitos reservados.", footer_tagline: "Land & Real Estate Investments",
  translating: "Traduzindo...",
};

UI.en = { ...UI.es,
  nav_home: "Home", nav_gallery: "Properties", nav_about: "About Us", nav_contact: "Contact", nav_admin: "Admin",
  hero_overline: "Investment Real Estate",
  hero_title: "Land, legacy,\nlong-term vision.",
  hero_sub: "Rural estates, large-scale urban developments, and industrial parcels. Exclusive land investment opportunities in Paraguay.",
  hero_cta: "Explore properties", hero_cta_alt: "Contact",
  cat_rural: "Rural", cat_urban: "Urban", cat_industrial: "Industrial",
  cat_rural_desc: "Estancias, productive farmland and native forests in South America's most fertile regions.",
  cat_urban_desc: "Strategic land for large-scale real estate developments with approved feasibility.",
  cat_industrial_desc: "Industrial and logistic parcels on strategic corridors with full services.",
  gallery_title: "Properties", gallery_sub: "A selection of patrimonial investment opportunities.",
  filter_all: "All", view_details: "View details", close: "Close",
  location: "Location", size: "Size", price: "Value", description: "Description", features: "Features", photos: "Photography",
  contact_for_info: "Request information",
  contact_title: "Contact us", contact_sub: "Our team responds to investment inquiries within 24 hours.",
  form_name: "Full name", form_email: "Email", form_phone: "Phone", form_message: "Message",
  form_submit: "Send inquiry", form_success: "Message sent. We'll be in touch shortly.",
  form_error: "An error occurred. Please try again.",
  admin_login: "Admin access", admin_email: "Email", admin_password: "Password", admin_enter: "Sign in",
  footer_rights: "All rights reserved.", footer_tagline: "Land & Real Estate Investments",
  translating: "Translating...",
};

UI.de = { ...UI.es,
  nav_home: "Start", nav_gallery: "Immobilien", nav_about: "Über uns", nav_contact: "Kontakt", nav_admin: "Admin",
  hero_overline: "Investment-Immobilien",
  hero_title: "Land, Vermögen,\nlangfristige Vision.",
  hero_sub: "Ländliche Güter, großmaßstäbliche Stadtentwicklungen und Industrieflächen. Exklusive Land-Investmentchancen in Paraguay.",
  hero_cta: "Immobilien entdecken", hero_cta_alt: "Kontakt",
  cat_rural: "Ländlich", cat_urban: "Urban", cat_industrial: "Industriell",
  cat_rural_desc: "Gutshöfe, produktives Farmland und Naturwälder in Südamerikas fruchtbarsten Regionen.",
  cat_urban_desc: "Strategisches Land für großmaßstäbliche Immobilienentwicklungen mit genehmigter Machbarkeit.",
  cat_industrial_desc: "Industrie- und Logistikgrundstücke an strategischen Korridoren mit voller Infrastruktur.",
  gallery_title: "Immobilien", gallery_sub: "Eine Auswahl an Vermögensinvestitionschancen.",
  filter_all: "Alle", view_details: "Details ansehen", close: "Schließen",
  location: "Lage", size: "Größe", price: "Wert", description: "Beschreibung", features: "Merkmale", photos: "Fotografie",
  contact_for_info: "Informationen anfordern",
  contact_title: "Kontaktieren Sie uns", contact_sub: "Unser Team antwortet auf Anfragen innerhalb von 24 Stunden.",
  form_name: "Vollständiger Name", form_email: "E-Mail", form_phone: "Telefon", form_message: "Nachricht",
  form_submit: "Anfrage senden", form_success: "Nachricht gesendet. Wir melden uns in Kürze.",
  form_error: "Ein Fehler ist aufgetreten. Bitte erneut versuchen.",
  admin_login: "Admin-Zugang", admin_email: "E-Mail", admin_password: "Passwort", admin_enter: "Anmelden",
  footer_rights: "Alle Rechte vorbehalten.", footer_tagline: "Land & Real Estate Investments",
  translating: "Übersetzen...",
};

UI.fr = { ...UI.es,
  nav_home: "Accueil", nav_gallery: "Propriétés", nav_about: "À propos", nav_contact: "Contact", nav_admin: "Admin",
  hero_overline: "Immobilier d'Investissement",
  hero_title: "Terre, patrimoine,\nvision durable.",
  hero_sub: "Domaines ruraux, développements urbains de grande envergure et parcelles industrielles. Opportunités exclusives d'investissement foncier au Paraguay.",
  hero_cta: "Explorer les biens", hero_cta_alt: "Contact",
  cat_rural: "Rural", cat_urban: "Urbain", cat_industrial: "Industriel",
  cat_rural_desc: "Estancias, terres productives et forêts natives dans les régions les plus fertiles d'Amérique du Sud.",
  cat_urban_desc: "Terrains stratégiques pour des développements immobiliers à grande échelle avec faisabilité approuvée.",
  cat_industrial_desc: "Terrains industriels et logistiques sur des corridors stratégiques avec services complets.",
  gallery_title: "Propriétés", gallery_sub: "Une sélection d'opportunités d'investissement patrimonial.",
  filter_all: "Toutes", view_details: "Voir les détails", close: "Fermer",
  location: "Emplacement", size: "Superficie", price: "Valeur", description: "Description", features: "Caractéristiques", photos: "Photographie",
  contact_for_info: "Demander des informations",
  contact_title: "Contactez-nous", contact_sub: "Notre équipe répond aux demandes sous 24 heures.",
  form_name: "Nom complet", form_email: "Email", form_phone: "Téléphone", form_message: "Message",
  form_submit: "Envoyer la demande", form_success: "Message envoyé. Nous vous recontactons rapidement.",
  form_error: "Une erreur s'est produite. Veuillez réessayer.",
  admin_login: "Accès admin", admin_email: "Email", admin_password: "Mot de passe", admin_enter: "Se connecter",
  footer_rights: "Tous droits réservés.", footer_tagline: "Land & Real Estate Investments",
  translating: "Traduction...",
};

export const t = (lang, key) => (UI[lang] && UI[lang][key]) || UI.es[key] || key;
